var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"dd-m-modal--error"},[_c('LogoIcon',{attrs:{"width":"32"}}),_c('strong',[_vm._v("Erro")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }